import axios from "axios";
import { RMAFormData, RMASendData } from "../utils/models/rma";
import { SEND_RMA_API_ENDPOINT } from "../utils/constants/api.constants";
import { DdtDetailsModel } from "../utils/models/ddt-details";
import { DdtDetailsListItemModel } from "../utils/models/ddt-details-list";

export async function sendRmaAPI(
    data: RMAFormData,
    ddt: DdtDetailsModel,
    bcCustomerNumber: string,
    ddtLineNo: string,
    foundRow: DdtDetailsListItemModel,
): Promise<boolean> {
    try {
        let now = new Date();
        const rtaRma = `RTA - ${now.getTime()}`;

        const body: RMASendData = {
            complaintType: "Product",
            customerNo: bcCustomerNumber,
            samples: "Available",
            signalingCode: "ALTRO",
            documentCode: "ALTRO",
            note: `${data.vat} - ${data.reason}`,
            openingDate: now.toISOString().slice(0, 10),
            openUserDate: now.toISOString().slice(0, 10),
            rtaRMA: rtaRma,
            complaintLines: [
                {
                    documentType: "Sales Shipment",
                    documentNo: ddt.ddtNumber,
                    documentLineNo: String(foundRow.lineNo),
                    itemNo: ddtLineNo,
                    rtaRMA: rtaRma,
                    description: foundRow.description + foundRow.description2,
                    variantCode: "",
                    lotNo: "",
                    serialNo: data.complaintLinesSerialNo,
                    locationCode: "",
                    binCode: "",
                    unitOfMeasureCode: "PZ",
                    complaintQuantity:
                        data.complaintQuantity > foundRow.quantity
                            ? Number(foundRow.quantity)
                            : Number(data.complaintQuantity),
                },
            ],
        };

        const rmaResponse = await axios.post(SEND_RMA_API_ENDPOINT, body);

        if (rmaResponse.status > 300) {
            return false;
        }

        return true;
    } catch (error) {
        console.error("Error sending rma:", error);
        throw error;
    }
}
